module.exports = __webpack_public_path__ + "static/kanal-analizi-9b8d03ba905a599be3b4af7ad41a4bde.png";